import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles(theme => ({
    dialogTitle:{
        '& > h2':{
           fontWeight:'bold'
        }
    }
}));


const AlertDialog= props=> {
    const classes=useStyles();
    const {open,onClose,title,children,onAccept, ...rest}=props;
    return (
        <div>
            <Dialog
                {...rest}
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {children}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        {props.onCloseText || 'لغو' }
                    </Button>
                    <Button onClick={onAccept} color="primary" autoFocus>
                        {props.onAcceptText || 'تایید'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AlertDialog;